import React, { useState } from "react";

const WaysToRedeemItem = ({
  imgUrl,
  title,
  desc,
  isButton = false,
  buttonText = "Redeem",
  disabled = true,
  onClickHandler,
  loading = false,
}) => {
  // const [loading, setLoading] = useState(false);
  return (
    <div className="waysToRedeem-item-container">
      <div className="waysToRedeem-item-image-container">
        <img src={imgUrl} alt="icon" />
      </div>
      <div className="waysToRedeem-item-text-container">
        <p className="waysToRedeem-item-text">{title}</p>
      </div>
      <div className="waysToRedeem-item-details-container">
        <span className="waysToRedeem-item-details">{desc}</span>

        <button
          style={{
            visibility: !isButton ? "hidden" : "visible",
          }}
          disabled={loading ? true : disabled}
          onClick={onClickHandler}
          className="waysToRedeem-item-button"
        >
          {loading ? <div className="loading-ring"></div> : buttonText}
        </button>
      </div>
    </div>
  );
};

export default WaysToRedeemItem;
